import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const ContextInfo = props => {
  return (
    <Fragment>
      <h3>Context Info</h3>
      <ul>
        <li>
          <b>Context ID:</b> {props.log.params.context_id}
        </li>
        <li>
          <b>Context Label:</b> {props.log.params.context_label}
        </li>
        <li>
          <b>Context Title:</b> {props.log.params.context_title}
        </li>
        <li>
          <b>Context Type:</b> {props.log.params.context_type}
        </li>
      </ul>
    </Fragment>
  )
}
export default ContextInfo

ContextInfo.propTypes = {
  log: PropTypes.object,
}
